import { useQuery } from '@tanstack/react-query'
import isEthereumAddress from 'validator/lib/isEthereumAddress'

import { getProfile } from '../helpers/Catalyst'
import { DclProfile } from '../helpers/Catalyst/types'

export default function useDclProfile(address?: string | null) {
  const fetchProfile = async () => {
    if (!address || !isEthereumAddress(address)) return null

    try {
      return await getProfile(address)
    } catch (error) {
      return null
    }
  }
  const { data: profile, isLoading: isLoadingDclProfile } = useQuery({
    queryKey: [`userProfile#${address?.toLowerCase()}`],
    queryFn: () => fetchProfile(),
  })

  return {
    profile: profile || ({} as DclProfile),
    isLoadingDclProfile,
  }
}
